import * as React from "react";
import "./menu-box.less";
import { MenuBoxGroupItem } from "./menu-box-group-item";
import { IProductCategoryModel } from "states/menu/menu.models";
import { SelectBranchModal } from "shared/components/select-branch/select-branch-modal";

export interface IMenuBoxProps {
  categories: IProductCategoryModel[]
}

export function MenuBox({ categories }: IMenuBoxProps) {
  return <>
    <div className={`flex-1 menu-box`}>
      <div className="px-10 py-8 md:px-6 md:py-6 sm:px-5 sm:py-4 xs:px-4 xs:py-4">
        <SelectBranchModal />
        {categories?.map((cate) => (<MenuBoxGroupItem key={cate.id} model={cate} />))}
      </div>
    </div>
  </>;
}
